<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-0.41,802.5v-7.27l0.91-0.91l0.91,0.91v7.27H-0.41L-0.41,802.5z M-5.86,798.86v-3.64h1.82v1.82h1.82v1.82H-5.86
	L-5.86,798.86z M3.23,798.86v-1.82h1.82v-1.82h1.82v3.64H3.23L3.23,798.86z M-2.23,793.41l-7.27,0v-1.81h7.27l0.91,0.91
	L-2.23,793.41L-2.23,793.41z M3.23,793.41l-0.91-0.91l0.91-0.91h7.27v1.81L3.23,793.41L3.23,793.41z M0.5,790.68l-0.91-0.91v-7.27
	h1.82v7.27L0.5,790.68L0.5,790.68z M-5.86,789.77v-3.64h3.64v1.82h-1.82v1.82H-5.86L-5.86,789.77z M5.05,789.77v-1.82H3.23v-1.82
	h3.64v3.64H5.05L5.05,789.77z"/>
</svg>

</template>